const sides = ['all', 'x', 'y', 'top', 'bottom', 'left', 'right'];
const clipValues = ['border-box', 'padding-box'];
const paddingValues = ['current', '0'];
const insetPropDefs = {
    side: { type: 'enum', values: sides, default: 'all', responsive: true },
    clip: { type: 'enum', values: clipValues, default: 'border-box', responsive: true },
    p: { type: 'enum', values: paddingValues, default: undefined, responsive: true },
    px: { type: 'enum', values: paddingValues, default: undefined, responsive: true },
    py: { type: 'enum', values: paddingValues, default: undefined, responsive: true },
    pt: { type: 'enum', values: paddingValues, default: undefined, responsive: true },
    pr: { type: 'enum', values: paddingValues, default: undefined, responsive: true },
    pb: { type: 'enum', values: paddingValues, default: undefined, responsive: true },
    pl: { type: 'enum', values: paddingValues, default: undefined, responsive: true },
};
export { insetPropDefs };
//# sourceMappingURL=inset.props.js.map